'use client';

import { useParams } from 'react-router-dom';

export default function OrganizationPage() {
  const { org_id } = useParams();

  return (
    <div className='p-8'>
      <span>Organization {org_id}</span>
    </div>
  );
}
